import React, { useState } from 'react';

import _ from 'lodash';
import { Button, FormControlLabel, Switch, useTheme } from '@material-ui/core';
import { GiTrophy } from 'react-icons/gi';
import { MdQueryStats } from 'react-icons/md';

import API from 'utils/api';
import { useSingleton, useSources } from 'hooks';
import { SectionTitle } from 'components';
import { classes } from 'utils';
import { Status } from './helpers';
import Lock from './Lock';
import PublishResultsDialog from './PublishResultsDialog';

import styles from './Results.module.scss';

const Results = ({ state, dispatch }) => {
  const [dialog, setDialog] = useState(false);

  const theme = useTheme();
  const sources = useSources();
  const singleton = useSingleton();

  const { id, status, results } = state;
  const highlight = { fontWeight: 'bold', color: theme.palette.primary.main };

  const redeem = (ticketId, value) =>
    singleton(async () => {
      const { data, error } = await API.redeemTicket(id, ticketId, value, sources);

      dispatch(
        error
          ? { type: 'ERROR', payload: error }
          : { type: 'REDEEM', payload: { ticketId, value: data } }
      );
    });

  const renderItem = ({ winner, numTickets, drawnSymbols, redeemed }, index) => {
    return (
      <div className={styles.item} key={winner.ticketId}>
        <div>
          <div className={styles.trophy}>
            <GiTrophy />
          </div>
          <div className={styles.ticket}>{winner.ticketCode}</div>
          <div className={styles.user}>
            {_.trim(winner.bearerName || 'Anonymous user')
              .replace(/\s+/g, ' ')
              .split(' ')
              .map(it => `${_.toUpper(it.charAt(0))}${it.substring(1)}`)
              .join(' ')}
          </div>
          <div className={styles.redeem}>
            <FormControlLabel
              control={
                <Switch
                  size="small"
                  checked={!!redeemed}
                  onChange={() => redeem(winner.ticketId, !redeemed)}
                  disabled={state.status !== Status.redemption}
                />
              }
              label="Redeemed"
              classes={{ label: styles.label }}
            />
          </div>
          <div className={styles.number}>{`#${index + 1}`}</div>
        </div>
        <div>
          <div>
            <MdQueryStats />
            <span>Competing tickets</span>
            <span>{numTickets}</span>
          </div>
          <div>Drawn symbols and matches</div>
          <div>
            <div className={styles.symbols}>
              {_.map(drawnSymbols, it => (
                <div key={it.value} className={classes(it.matches ? styles.match : '')}>
                  <span>{it.value}</span>
                  <span>{it.matches}</span>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    );
  };

  return (
    <div className={styles.results}>
      <div className={styles.header}>
        <SectionTitle title="Results">
          {status < Status.closed ? (
            <>
              When the ticketing period is over, the draw can be held and the winners will
              be shown on this panel
            </>
          ) : status === Status.closed ? (
            <>
              Click on the <span style={highlight}>DRAW</span> button to find out who the
              lucky users will be
            </>
          ) : (
            <>Behold the champions!!</>
          )}
        </SectionTitle>
      </div>

      {status > Status.closed ? (
        <>
          {_.map(results, renderItem)}

          <div className={styles.bottom}>
            <Button
              variant="contained"
              color="primary"
              onClick={() => setDialog(true)}
              disabled={status !== Status.redemption}
            >
              publish
            </Button>
          </div>
        </>
      ) : (
        <Lock
          label={
            status === Status.closed
              ? 'Click on the DRAW button above to find the winners'
              : [
                  'When the ticketing period is over and the drawing is held,',
                  'the winners will be shown here',
                ]
          }
        />
      )}

      <PublishResultsDialog id={id} open={dialog} onClose={() => setDialog(false)} />
    </div>
  );
};

export default Results;
